import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../../assets/styles/Navbar.module.scss';

export default function NavBar() {
  const [navOpen, setNavOpen] = useState(false);
  const handleNav = () => setNavOpen(!navOpen);

  return (
    <div className="relative lg:fixed w-full z-50">
      <nav className={styles.nav}>
        <div
          style={{ backgroundColor: '#eeeeee' }}
          className="w-full flex flex-row justify-between items-center p-4 lg:w-auto"
        >
          <div>
            <Link to={'/'}>
              <span className={'font-bold text-2xl text-gray-800'}>
                SmartRewards
              </span>
            </Link>
          </div>
          <div className="lg:hidden" onClick={() => handleNav()}>
            <i
              style={{ color: '#f59e0b', fontSize: 28 }}
              className={navOpen ? 'fas fa-times' : 'fas fa-bars'}
            />
          </div>
        </div>
        <div
          className={
            navOpen
              ? `${styles.navitems} ${styles.active}`
              : `${styles.navitems}`
          }
        >
          <div className="flex flex-col mb-10 lg:mb-0 w-full lg:w-auto lg:flex-row lg:mr-2">
            {/* {['About', 'Contact', 'Testimonials'].map((item, index) => (
              <span href="#" key={index} className={styles.navlink}>
                {item}
              </span>
            ))} */}
          </div>
          <div className="flex flex-col w-full lg:w-auto lg:flex-row items-center justify-center">
            <Link to={'/login'}>
              <span
                className={
                  'w-full lg:w-auto border-2 rounded leading-none border-yellow-500 text-yellow-500 px-4 py-2 text-sm lg:text-lg'
                }
              >
                Login to account
              </span>
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
}

// {/* <div>
//   <Link to={'/dashboard'}>
//     <a
//       className={
//         'border-2 rounded-sm border-yellow-500 text-yellow-500 px-4 py-2 text-sm'
//       }
//     >
//       Dashboard
//     </a>
//   </Link>
// </div> */}
